<template>
    <div></div>
</template>
<script type="text/javascript">
export default {
    methods: {
        EnviarFormularioAdjunto() {
            const formData = new FormData();
            const archivo = document.querySelector("#archivo").files[0];
            formData.append("archivo", archivo);
            formData.append("ficha", this.$route.params.id);
            const tipoArchivo = document.querySelector("#tipo_archivo").value;
            formData.append("tipo_archivo", tipoArchivo);

            axios
                .post("./../adjuntar-archivo", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.VerAdjunto();
                    document.querySelector("#archivo").value = "";
                    document.querySelector("#tipo_archivo").value = "";
                    alert(response.data.message);
                })
                .catch((error) => {
                    alert(error.response.data.message);
                });
        },
        VerAdjunto() {
            axios
                .post("./../archivos-adjuntos/" + this.$route.params.id)
                .then((response) => {
                    this.archivos = response.data;
                })
                .catch((error) => {});
        },
        irPaginaAnterior() {
            this.$router.push({
                name: "PendientesRegistro",
            });
        },
        ImprimirFicha() {
            const url = this.$root.UrlBase("fichas/imprimir/" + this.ficha.id);
            window.open(url, "_blank");
        },

        EliminarFicha() {
            if (
                window.confirm(
                    "¿Estás seguro de que deseas eliminar esta ficha?"
                )
            ) {
                axios
                    .post("./" + this.$route.params.id + "/eliminar")
                    .then((response) => {
                        alert(response.data.message);
                        this.irPaginaAnterior();
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            } else {
                console.log("Eliminación cancelada");
            }
        },
        RecuperarFicha() {
            if (
                window.confirm(
                    "¿Estás seguro de que deseas recuperar esta ficha?"
                )
            ) {
                axios
                    .post("./" + this.$route.params.id + "/recuperar")
                    .then((response) => {
                        alert(response.data.message);
                        this.irPaginaAnterior();
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            } else {
                console.log("Eliminación cancelada");
            }
        },
        VolverEtapa() {
            if (
                window.confirm(
                    "¿Estás seguro de que deseas volver a la etapa anterior?"
                )
            ) {
                axios
                    .post("./" + this.$route.params.id + "/volver-etapa")
                    .then((response) => {
                        this.irPaginaAnterior();
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            } else {
                console.log("Eliminación cancelada");
            }
        },
        EliminarAdjunto(registro) {
            if (
                window.confirm(
                    "¿Estás seguro de que deseas eliminar este adjunto?"
                )
            ) {
                axios
                    .post("./../eliminar-adjuntos/" + registro)
                    .then((response) => {
                        this.VerAdjunto();
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            } else {
                console.log("Eliminación cancelada");
            }
        },
        async EnvivarFormulario() {
            let formulario = document.getElementById(
                "CreacionEdicionFichasSgi"
            );

            let form = new FormData(formulario);

            this.$root
                .Consulta(
                    "crear-editar-fichas",
                    form,
                    "post",
                    false,
                    true,
                    ".card-body",
                    "initial"
                )
                .then((response) => {
                    if (response.ficha_id) {
                        if (typeof this.$route.params.id != "undefined") {
                            this.irPaginaAnterior();
                        } else {
                            if (confirm("¿Quieres Adjuntar un Archivo?")) {
                                this.$router.push({
                                    name: "NuevoRegistroEditar",
                                    params: { id: response.ficha_id },
                                    query: { subirArchivo: "S" },
                                });
                            } else {
                                this.irPaginaAnterior();
                            }
                        }
                    }
                });
        },
        cambios(array) {
            if (!this.$route.params.id) {
                if (array.etapa == 0 && array.values.tipo_nc != this.tipo_nc) {
                    this.forms.splice(1, 100);

                    this.$root
                        .Consulta(
                            this.$root.UrlBase("fichas/formulario/crear-edita"),
                            {
                                tipo_nc: array.values.tipo_nc,
                                etapa: array.etapa,
                            },
                            "post",
                            false,
                            false,
                            false,
                            "",
                            false
                        )
                        .then((response) => {
                            if (response[0].attr) {
                                this.forms[0].form[0][0].attrs.splice(3, 1);
                                this.forms[0].form[0][0].attrs.push(
                                    response[0].attr
                                );
                                this.edit++;
                            }

                            for (let key in response) {
                                if (key > 0) {
                                    this.forms.push({
                                        config: {},
                                        form: [
                                            [
                                                {
                                                    col: "12",
                                                    title: response[key].etapa
                                                        .nombre,
                                                    etapa_actual:
                                                        response[key].etapa
                                                            .etapa_actual,
                                                    etapa_campo:
                                                        response[key].etapa
                                                            .etapa_campo,
                                                    footer: {},
                                                    attrs: [response[key].attr],
                                                },
                                            ],
                                        ],
                                    });
                                    this.edit++;
                                }
                            }
                        });
                }
            }
        },
        BuscarFicha() {
            this.forms = [];
            this.$root
                .Consulta("", {}, "post", false, false, ".card-body", "initial")
                .then((response) => {
                    for (let key in response) {
                        if (response[key].ficha) {
                            this.ficha = response[key].ficha;
                        }
                        this.forms.push({
                            config: {
                                actual: response[key].etapa.actual,
                            },
                            form: [
                                [
                                    {
                                        col: "12",
                                        title: response[key].etapa.nombre,
                                        etapa_actual:
                                            response[key].etapa.etapa_actual,
                                        etapa_codi:
                                            response[key].etapa.etapa_codi,
                                        ficha: response[key].ficha,
                                        footer: {},
                                        attrs: [response[key].attr],
                                    },
                                ],
                            ],
                        });
                        this.edit++;
                    }
                });
            this.edit++;
        },
    },
    data() {
        return {};
    },
    created() {
        let currentUrl = window.location.href;

        // Reemplazar 'registros' por 'fichas/NC'
        let newUrl = currentUrl.replace("registros", "fichas/NC");

        // Redirigir a la nueva URL
        window.location.href = newUrl;
    },
    watch: {},
};
</script>
